/* tslint:disable:max-line-length */
import { SegmentSpecificMessages } from "../../types/types";

export const memberMessages: SegmentSpecificMessages = {
  step: {
    personalInfo: {
      title: "Unlock this Members-Only Offer",
      subtitle: "Verify you're a current member of an eligible organization.",
      howDoesVerifyingWorkDetails:
        "{companyName} has set up this special offer for all current members of select organizations." +
        "<br></br>" +
        "{companyName} uses SheerID, a trusted partner, to verify that you are currently employed. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: "Check the information that you have provided",
        subtitle: "The information you have provided should match your official documents.",
      },
      verifyingTitle: "Verifying your membership status",
      submitButtonText: "Verify My Membership Status",
    },
    docUpload: {
      uploadInstructions: "Upload an official document that shows",
      title: "To continue, upload documents that confirm an active membership",
      whoIsSheerId:
        "Document review is handled by SheerID, a trusted partner who specializes in verifying members.",
    },
    success: {
      title: "You've been verified",
      subtitle: "You are now eligible for this special offer.",
      redirectButtonText: "Continue",
    },
  },
};
